(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Newsletter-accordion-sec"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $(document).on('click', '.loadmore_btn', function () {
      var parentAccordion = $(this).closest('.accordion_readmore');
      var siblingBlockDiv = parentAccordion.siblings('.block_div');
      var siblingBlockDivFlex = parentAccordion.siblings('.block_div_flex');

      siblingBlockDiv.removeClass('hide');
      siblingBlockDivFlex.css('display', 'flex');

      $(this).remove();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-image-with-text-overlay"] && !Shopify.designMode) return;
  try {
    
/**
 * Open community link in new tab after login
 */
const url = window.location.href;
if(url.includes('?logged=true')) {
  const new_url = url.split('?')[0];
  history.replaceState({}, document.title, window.location.href.split('?')[0]);
  const commmunityLink = document.getElementById('community-link');
  if (commmunityLink) {
    const url = commmunityLink.getAttribute('href');
    const newTab = window.open(url, '_blank');
    newTab.focus();
  }
}

/**
 * Open login model on login button click
 */
const handleLoginClick = () => {
  event.preventDefault();
  $(".custom-model-main").addClass('model-open');
  $("body").addClass('login-model-open');
};

const loginLink = document.getElementById("login-link");
if (loginLink) {
  loginLink.addEventListener("click", handleLoginClick);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-list"]) return;
  try {
    
	$(document).on('change', '#blog_category,#tags', function() {
		var url = $(this).find('option:selected').attr('data-url');
		if($(this).hasClass('blog_category')){
			$(this).find('option').eq(0).attr('disabled','disabled');
		}
		if(url){
			window.location.href = url;
		}
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["register"]) return;
  try {
    
$('#register_agreement').scroll(function () {
  if (this.scrollHeight - this.scrollTop <= this.clientHeight + 1) {
    $('#register_accept_agreement').removeAttr('disabled');
    $('#register_accept_agreement').siblings('label').removeClass('disabled');
  }
});

$('.radiobtn_field input[type="radio"]').on('change', function () {
  var value = $(this).val();
  if (value == 'true') {
    $('.radiobtn_field .extra-text-wrapp').css('display', 'block');
  } else {
    $('.radiobtn_field .extra-text-wrapp').css('display', 'none');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-blog-with-category"]) return;
  try {
    
	$(document).on('change', '#blog_category,#tags', function() {
		var url = $(this).find('option:selected').attr('data-url');
		if($(this).hasClass('blog_category')){
			$(this).find('option').eq(0).attr('disabled','disabled');
		}
		if(url){
			window.location.href = url;
		}
	});

  } catch(e) { console.error(e); }
})();
})();
